<template>
  <div>
    <h1 class="mobiTitle white lg content" id="contentTitle">
      {{$t("popular")}}
      </h1>
      <div class="main_wrap">
          <div class="mobiSection">
            <div class="mobiSection__header">
              <h2 class="mobiTitle md">
                <img class="mobiIcon" :src="IconPopular_Mobif" alt=""/>
                <span class="text_color">{{$t("all")}} {{$t("popular")}}</span>
              </h2>
            </div>
            <div class="mobiSection__content">
              <div class="row">
                <div class="col-6 col-md-4 col-lg-4 col-sm-6 mobiColItem" v-for="pop in PopularPage_Mobif" :key="pop.key">
                  <router-link class="browse_link mobiVideo mobiVideo--mrgn" :to="{
                    name: 'DetailPage',
                    params: { id: pop.content_id }
                    }">
                  <!-- <div v-if="pop.content_type === 'application/x-zip-compressed'" class="mobibadge badge--html5">
                    <img src="../../assets/mobizone/imgs/html5-badge.png"/>
                  </div> -->
                  <div class="mobiVideo__thumb">
                    <img class="img_wrp" :src="pop.cover_img" alt="" />
                  </div>
                  <div class="playBtn"><span></span></div>
                  <div class="mobiVideo__info">
                      <!-- <h3 class="mobiTitle sm text_color">{{ pop.content_name }}</h3> -->
                      <span v-if="lang_Mobif !== 'english'">
                      <h3 class="mobiTitle sm" v-if="pop[`cont_name_${lang_Mobif}`] !== ''">{{ pop[`cont_name_${lang_Mobif}`] }}</h3>
                      <h3 class="mobiTitle sm" v-else>{{ pop[`cont_name_english`] }}</h3>
                    </span>
                    <span v-else>
                      <h3 class="mobiTitle sm">{{ pop[`cont_name_english`] }}</h3>
                    </span>
                    <div>
                        <!-- <p>{{ pop.total_download }} {{$t("downloads")}}</p> -->
                      <star-rating :inline="true" :star-size="16" :read-only="true" :increment="0.01" :show-rating="false" :border-width="2" border-color="#feb801" inactive-color="transparent" active-color="#ffb902" :rounded-corners= "false" :star-points="[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17]"
                      :rating="Number(pop.rating)"></star-rating>
                    </div>
                  </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
      </div>
    
    <!-- <select name="" id="" @change="fetchPagePopular($event)">
        <option value="">--Select View--</option>
        <option value="200">200</option>
        <option value="100">100</option>
        <option value="50">50</option>
        <option value="20">20</option>
        <option value="10">10</option>
        <option value="5">5</option>
    </select> -->
    <!-- <div class="main_part">
        <div v-for="pop in pagePopular" :key="pop.key">
            <router-link class="browse_link" :to="{
                name: 'DetailPage',
                params: { id: pop.id }
                }"><img :src="pop.thumbnail_url" alt="">
            </router-link>
            <p>{{pop.content_name}}</p>
            <p>{{pop.total_download}} Downloads</p>
            <star-rating :inline="true" :star-size="20" :read-only="true" :increment="0.01" :show-rating="false" :border-width="4" border-color="#FFA500" :rounded-corners="true" :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]" :rating="Number(pop.rating)"></star-rating>
            
        </div>
    </div> -->
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import StarRating from 'vue-star-rating';
// Vue.component("star-rating", VueStarRating.default);

export default {
  components:{
    StarRating
  },
  computed: mapGetters(["PopularPage_Mobif", "IconPopular_Mobif", "lang_Mobif"]),
  created() {
    this.fetchPagePopular_Mobif();
  },
  methods: {
    ...mapActions(["fetchPagePopular_Mobif"])
  }
};
</script>

<style scoped>
.main_title {
  color: black;
}
.main_part div {
  display: inline-block;
  padding: 0 3px;
  color: black;
}
.browse_link {
  color: black;
}

.icon {
  height: 32px;
  width: 32px;
}
</style>


// WEBPACK FOOTER //
// src/components/mobiflix/Popular.vue